import React from 'react'
import userSessionStorage from '@/context/userSessionStorage'
import ForumServices from '@/services/forum-service'
import wallHeart from '../../../assets/images/icons/wall-heart.png'
import { callModal } from '../modal-viewer/modal-viewer'
import useUserLogged from '@/hooks/useUserLogged'
import { LOCALE_AT, forumId } from '@/constants/activity-constants'
import Button from '@/components/atoms/button/button'
import { triggerTageo } from '@/utils/tagging-util'
const $Cuentanos = LOCALE_AT.PARAGUAY ? 'Contanos' : 'Cuentanos'
const $Intenta = LOCALE_AT.PARAGUAY ? 'Intentá' : 'Intenta'

const textAreaRegex = /^[a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/

function sendComent(forumId, text) {
  const token = userSessionStorage.getToken()
  if (!token) {
    return false
  }
  const config = {
    headers: {
      Authorization: token.idToken,
    },
  }
  return ForumServices.saveFormuComment(forumId, text, config)
}
const doLogin = () => {
  return new Promise(resolve => {
    callModal('login', {
      forAccess: 'comentar en nuestro Wall of Love',
      onClose: logged => {
        resolve(logged)
      },
    })
  })
}
const ShareSupportText = () => {
  if (LOCALE_AT.PARAGUAY) {
    return <p className="share-support">ESCRIBÍ • COMPARTÍ • APOYÁ</p>
  }
  return <p className="share-support">ESCRIBE • COMPARTE • APOYA</p>
}
const CardInput = ({ onPageUpdate, onUseToast }) => {
  const { isLogged } = useUserLogged()
  const [isLoading, setIsLoading] = React.useState(false)
  const [commentError, setCommentError] = React.useState('')
  const commentRef = React.useRef(null)

  const handleFormSubmit = async e => {
    e.preventDefault()
    if (isLoading) {
      return false
    }

    if (!isLogged) {
      const _logedd = await doLogin()
      if (!_logedd) {
        return false
      }
    }

    const comentario = commentRef.current.value.trim()
    if (!comentario) {
      setCommentError('El comentario no puede estar vacío.')
      return false
    } else if (comentario.length < 30) {
      setCommentError('El comentario debe tener al menos 30 caracteres.')
      return false
    } else if (comentario.length > 250) {
      setCommentError('El comentario no puede tener más de 250 caracteres.')
      return false
    }

    setIsLoading(true)
    setCommentError('')
    const resp = await sendComent(forumId, comentario)
    if (resp.status === 200) {
      e.target.reset()
      onPageUpdate()
      onUseToast(
        <p className="flex --justify-start">
          <span className="icon-circle-check"></span>Tu comentario ha sido
          compartido
        </p>
      )

      triggerTageo('12A', {
        label: 'Enviar',
        location:
          window.location.host + window.location.pathname + '#foro',
      })
    } else {
      onUseToast(
        <p className="flex --justify-start ">
          <span className="icon-circle-x"></span>¡Ups! Tu comentario no se ha
          podido publicar. {$Intenta} de nuevo.
        </p>
      )
    }


    setIsLoading(false)

    return false
  }

  return (
    <>
      <div className="f-forum-section-wall">
        <div className="f-forum-section-wall-title">
          <p>
            <img src={wallHeart} alt="wallHeart" /> FORO
          </p>
          <h2>
            WALL OF <span className="love">LOVE</span>
          </h2>
        </div>
        <form onSubmit={handleFormSubmit} className="f-forum-section-form box">
          <div>
            <p className="history">
              {$Cuentanos} tu historia de bullying y juntos{' '}
              <span>rompamos el silencio</span>
            </p>
            <ShareSupportText />
          </div>
          <textarea
            ref={commentRef}
            name="comentario"
            placeholder="Comenta..."
            onChange={e => {
              if (!textAreaRegex.test(e.target.value)) {
                return false
              }
              return true
            }}
          ></textarea>
          {commentError && <p className="error-message">{commentError}</p>}
          <Button type="submit" loading={isLoading} disabled={isLoading}>
            Enviar
          </Button>
        </form>
      </div>
    </>
  )
}

export default CardInput
